import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["insight", "correlationId", "appUsageTracker", "label", "report", "dataset"];
import { useState } from 'react';
import { Text } from 'foundations-components/components/Text';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import NegativeFeedbackButton from './NegativeFeedbackButton';
import PositiveFeedbackButton from './PositiveFeedbackButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeedbackButtons = _ref => {
  let {
      insight,
      correlationId,
      appUsageTracker,
      label,
      report,
      dataset
    } = _ref,
    spacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [disableFeedback, setDisableFeedback] = useState(false);
  return /*#__PURE__*/_jsxs(ButtonWrapper, Object.assign({
    display: "flex",
    flexDirection: "row",
    flexGrow: 0,
    flexShrink: 0
  }, spacingProps, {
    children: [label && /*#__PURE__*/_jsx(Text, {
      as: "p",
      color: "text-interactive-default",
      wordBreak: "keep-all",
      children: label
    }), /*#__PURE__*/_jsx(PositiveFeedbackButton, {
      disableFeedback: disableFeedback,
      setDisableFeedback: setDisableFeedback,
      insight: insight,
      correlationId: correlationId,
      appUsageTracker: appUsageTracker,
      report: report,
      dataset: dataset
    }), /*#__PURE__*/_jsx(NegativeFeedbackButton, {
      disableFeedback: disableFeedback,
      setDisableFeedback: setDisableFeedback,
      insight: insight,
      correlationId: correlationId,
      appUsageTracker: appUsageTracker,
      report: report,
      dataset: dataset
    })]
  }));
};
export default FeedbackButtons;